import { AppDispatch } from "app/store";
import { EMAIL_MAX_LENGTH } from "common/constants";
import OmronHeader from "components/OmronHeader";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import OmronFooter from "../../components/OmronFooter";
import { resetRequestAsync } from "../../features/reset/operations";
import { changeEmail } from "../../features/reset/resetSlice";

const ResetRequest: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();

  const onSendResetEmail = useCallback(async () => {
    dispatch(resetRequestAsync());
  }, [dispatch]);

  const onChangeEmail = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(changeEmail({ email: e.target.value }));
    },
    [dispatch]
  );

  return (
    <MainWrapper>
      <OmronHeader
        link={{ path: "/", label: t("common.label.breadcrumbsSignin") }}
        label={[t("common.label.breadcrumbsResetRequest")]}
      />
      <PageMain>
        <InnerDiv>
          <ResetTitle>{t("resetPage.label.resetRequestTitle")}</ResetTitle>
          <Text>{t("resetPage.text.resetRequest")}</Text>
          <section>
            <form>
              <ResetDl>
                <ResetDt>
                  {t("resetPage.label.email")}
                  <Required>{t("resetPage.label.required")}</Required>
                </ResetDt>
                <ResetDd>
                  <ResetInput
                    type="email"
                    size={40}
                    maxLength={EMAIL_MAX_LENGTH}
                    name="email"
                    onChange={onChangeEmail}
                  />
                </ResetDd>
                <ButtonDd>
                  <ResetButton
                    type="button"
                    value={t("resetPage.label.sendEmailButton")}
                    onClick={onSendResetEmail}
                  />
                </ButtonDd>
                <ButtonDd>
                  <LoginLink href="/">
                    {t("resetPage.label.loginLink")}
                  </LoginLink>
                </ButtonDd>
              </ResetDl>
            </form>
          </section>
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </MainWrapper>
  );
};
export default ResetRequest;

const MainWrapper = styled.div`
  display: grid;
  grid-template-rows: 76px 40px 1fr auto;
  grid-template-areas: "header" "breadc" "main" "footer";
  min-height: 100vh;
`;
const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;

const ResetTitle = styled.h1`
  margin-bottom: 3rem;
`;

const ResetDt = styled.dt`
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  background: #fafafa;
  width: 26%;
  padding: 1.3rem 2%;
  margin-bottom: 2rem;
`;

const ResetDl = styled.dl`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 3rem;
`;

const ResetDd = styled.dd`
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  background: #fafafa;
  width: 70%;
  padding: 1rem 0;
  margin-bottom: 2rem;
`;

const ButtonDd = styled.dd`
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  width: 100%;
  background: none;
  text-align: center;
  padding: 1rem 0;
`;

const ResetInput = styled.input`
  padding: 0.5rem 0.8rem;
  border: 1px #999999 solid;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  :focus {
    outline: 0;
    background: #fafafa;
  }
`;
const ResetButton = styled.input`
  width: 15rem;
  padding: 1.23rem 2rem;
  border: 1px #005eb8 solid;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  opacity: 1;
  pointer-events: auto;
  box-sizing: inherit;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  cursor: pointer;
  color: #ffffff;
  background: #005eb8;
  :hover {
    background: rgba(0, 94, 184, 0.7);
  }
`;

const LoginLink = styled.a`
  color: #005eb8;
  text-decoration: none;
  cursor: pointer;
`;
const Text = styled.p`
  margin-bottom: 3rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  white-space: pre-wrap;
`;

const Required = styled.p`
  display: inline-block;
  color: #e50000;
  float: right;
  padding-top: 0.3rem;
  font-size: 11px;
  line-height: 1.6;
  letter-spacing: 0;
  font-weight: normal;
`;
